export class DocumentType
{
  code: string;
  name: string;
  requiresSubType: boolean;
  caseTypes: string;
  caseCategoryTypes: string;
  formGroups: string;
  metaDataItems: string;
}
